angular.module('capability-ng-scheduler').factory('SectionTimeBuilder', function SectionTimeBuilder(Interface) {
  var DTD = {
    id: 'key',
    nk: 'string',
    section: 'integer',
    day_of_week: 'integer',
    from_tm: {
      type: 'moment',
      typeDef: 'HH:mm:ss',
      rules: {
        defaultToNow: false
      }
    },
    to_tm: {
      type: 'moment',
      typeDef: 'HH:mm:ss',
      rules: {
        defaultToNow: false
      }
    },
    location: 'integer',
    _location: 'object'
  };

  function SectionTimeDTO(data) {
    Interface.implement(DTD, data, this);
  }
  return SectionTimeDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/section_time_builder.es.js